<template lang="pug">
f7-page#invalid-token
  navbar(title="パスワード再設定の反映")

  background
    .label-area
      p.title パスワード再設定リンクエラー
      p
        | 有効期限が切れています。
        br
        | 再度パスワードの再設定リクエストからお試しください。
</template>

<style lang="scss" scoped>
.label-area {
  padding-left: 16px;
  padding-right: 16px;
}
.title {
  @extend %headline-detail-text;
  margin-top: 48px;
}

.button-area {
  position: absolute;
  bottom: 32px;
  width: 100%;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import LargeButton from '@/components/atoms/LargeButton'

export default {
  mixins: [PageTitle],
  title: 'パスワード再設定の反映',
  components: {
    LargeButton,
  },
  data() {
    return {
      isValid: false,
    }
  },
}
</script>
